export default "__VITE_ASSET__062eba6a__"